import { Box, BoxProps, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

import AppTooltip from "../Tooltip/AppTooltip";
import { StatusIndicator, StatusIndicatorProps } from "./StatusIndicator";

export interface StatusDisplayProps {
  title?: ReactNode | null;
  subtitle?: ReactNode | null;
  variant?: "default" | "compact";
  indicatorProps?: Partial<StatusIndicatorProps>;
  indicator?: ReactNode;
  sx?: BoxProps["sx"];
}

export function StatusDisplay({
  variant = "default",
  title,
  subtitle,
  indicatorProps,
  indicator,
  sx,
}: StatusDisplayProps) {
  return (
    <>
      {variant === "default" && (
        <Box
          component='span'
          sx={{ display: "inline-flex", flexDirection: "row", alignItems: "center", ...sx }}
        >
          {indicator || <StatusIndicator size='small' {...indicatorProps} />}

          {(title || title) && (
            <Stack sx={{ ml: 0.5 }}>
              {title && <Typography>{title}</Typography>}
              {subtitle && (
                <Typography sx={{ color: (th) => th.palette.grey[400] }}>{subtitle}</Typography>
              )}
            </Stack>
          )}
        </Box>
      )}

      {variant === "compact" && (
        <AppTooltip title={title!} wrapperProps={{ component: "span" }}>
          <Box
            component='span'
            sx={{ display: "inline-flex", flexDirection: "row", alignItems: "center", ...sx }}
          >
            {indicator || <StatusIndicator size='small' {...indicatorProps} />}
          </Box>
        </AppTooltip>
      )}
    </>
  );
}
